import { useCallback, useEffect, useState } from "react";
import { HardDriveDownload } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { offlineFilesCount, clearOfflineFiles, storageEstimate } from "../lib/offline";
import { Button } from "./ui/button";

const fmtMB = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;

export default function OfflineCard() {
  const { t } = useAuth();
  const [count, setCount] = useState(0);
  const [est, setEst] = useState({ used: 0, quota: 0 });
  const load = useCallback(async () => {
    setCount(await offlineFilesCount());
    setEst(await storageEstimate());
  }, []);
  useEffect(() => {
    load();
    window.addEventListener("rannea-offline-changed", load);
    return () => window.removeEventListener("rannea-offline-changed", load);
  }, [load]);
  const clear = async () => {
    await clearOfflineFiles();
    toast.success(t("offline.cleared"));
  };
  return (
    <div className="app-card p-6 space-y-3 max-w-lg" data-testid="offline-card">
      <h3 className="font-heading text-lg font-bold flex items-center gap-2"><HardDriveDownload className="h-5 w-5 accent" /> {t("offline.card_title")}</h3>
      <p className="text-xs t-secondary">{t("offline.card_desc")}</p>
      <p className="text-sm" data-testid="offline-usage">
        {t("offline.files_count", { n: count })} — {t("offline.usage", { used: fmtMB(est.used), quota: est.quota ? `${(est.quota / (1024 ** 3)).toFixed(1)} Go` : "?" })}
      </p>
      {count > 0 && (
        <Button variant="outline" size="sm" className="border-app" onClick={clear} data-testid="offline-clear-button">{t("offline.clear")}</Button>
      )}
    </div>
  );
}
